module.exports = __webpack_public_path__ + "img/goods10.864d4225.jpg";